import { render, staticRenderFns } from "./chirurgie.vue?vue&type=template&id=07f8738f"
import script from "./chirurgie.vue?vue&type=script&lang=js"
export * from "./chirurgie.vue?vue&type=script&lang=js"
import style0 from "./chirurgie.vue?vue&type=style&index=0&id=07f8738f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports